import * as apiActions from 'actions/apiEndCategorisActions';


export default function api(state = {isFetching: true}, action){
	switch (action.type){
		case apiActions.REQUEST_START:
			return Object.assign({}, state, {isFetching: true});
		case apiActions.REQUEST_END:
			return Object.assign({}, state, {isFetching: false});
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./frontend/reducers/api.js